import { useMemo, useRef } from "react";
import { SchedulesForm } from "../../components/forms/SchedulesForm";
import Modal from "../../components/ui/Modal";
import { StatusMessage } from "../../components/ui";
import type { CreateScheduleRequest, ScheduleDetail } from "../../services/configuration/configuration.types";
import { mapScheduleToForm } from "./scheduleForm";

interface Props {
    schedule: ScheduleDetail | null;
    submitting: boolean;
    error: string | null;
    onSave: (values: CreateScheduleRequest) => Promise<void>;
    onCancel: () => void;
    onClearError: () => void;
}

export function ScheduleEditor({ schedule, submitting, error, onSave, onCancel, onClearError }: Props) {
    const formRef = useRef<HTMLFormElement>(null);
    const initialData = useMemo(() => schedule ? mapScheduleToForm(schedule) : undefined, [schedule]);
    const cancel = () => { if (!submitting) onCancel(); };
    return (
        <Modal isOpen title={schedule ? "Edit Schedule" : "Add Schedule"}
            okButtonLoading={submitting} cancelButtonLoading={submitting}
            onConfirm={() => { if (!submitting) formRef.current?.requestSubmit(); }} onCancel={cancel}
            content={
                <>
                    {error && <StatusMessage kind="error" onClose={onClearError}>{error}</StatusMessage>}
                    <SchedulesForm initialData={initialData} formRef={formRef} hideSubmitButton
                        isLoading={submitting} onSubmit={async values => { if (!submitting) await onSave(values); }}
                        onCancel={cancel} />
                </>
            }
        />
    );
}
